module.exports = __webpack_public_path__ + "static/media/logo60@3x.c0cddf20.png";